import React, { useState } from "react"

import { L10n } from "@encoway/l10n"

import { TranslationConstants } from "../../constants/translationConstants"
import { DefaultPrimaryButton } from "../DefaultPrimaryButton/DefaultPrimaryButton"
import CsvExportDialog from "./CsvExportDialog"

export default function CsvExportButton() {
    const [showDialog, setShowDialog] = useState<boolean>(false)

    return (
        <>
            <DefaultPrimaryButton onClick={() => setShowDialog(true)}>
                {L10n.format(TranslationConstants.Toolbar.BUTTON_CSV_EXPORT)}
            </DefaultPrimaryButton>
            {showDialog && (
                <CsvExportDialog onClose={() => setShowDialog(false)} />
            )}
        </>
    )
}
